export default "__VITE_ASSET__70471b85__"